import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sdk } from '../lib/sdk';

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const token = params.get('token');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) return;
    setError(null);
    if (password !== confirm) {
      setError(t('settings.security.mismatched'));
      return;
    }
    setBusy(true);
    try {
      await sdk.auth.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      // The API rejects with descriptive messages now (Zod validator
      // surfaces field names; auth.service maps domain failures to
      // ApiError keys). Surface whatever it gave us verbatim.
      setError(err instanceof Error ? err.message : 'Reset failed');
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <main style={page}>
        <p style={{ color: 'red' }}>Missing token. <Link to="/forgot-password">Request a new reset link.</Link></p>
      </main>
    );
  }

  return (
    <main style={page}>
      <h1>Reset password</h1>

      {done ? (
        <p>Password updated. Redirecting to sign in…</p>
      ) : (
        <form onSubmit={onSubmit} style={form_}>
          <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>
            Must be at least 8 characters and include a letter and a number.
          </p>

          <label style={label}>
            New password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoFocus
              style={input}
            />
          </label>

          <label style={label}>
            Confirm new password
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={8}
              style={input}
            />
          </label>

          <button type="submit" disabled={busy} style={btn}>
            {busy ? t('common.loading') : 'Set new password'}
          </button>

          {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
        </form>
      )}
    </main>
  );
}

const page: React.CSSProperties = { maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif', padding: '0 1rem' };
const form_: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '1rem' };
const label: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '0.25rem' };
const input: React.CSSProperties = { padding: '0.5rem', border: '1px solid #ccc', borderRadius: 4, font: 'inherit' };
const btn: React.CSSProperties = { padding: '0.5rem 1rem', cursor: 'pointer' };
